module.exports = __webpack_public_path__ + "img/89.0cd07502.jpg";